import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWillsAndTrustsFormalExecutionAndAttestationRequirementsForAValidWillPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-wills-and-trusts/formal-execution-and-attestation-requirements-for-a-valid-will/']} />;
}
